/**
 * Created by chachora on 11/28/18.
 */
import { AnyAction } from 'redux';
import * as actionTypes from './statistics.actions';
import { SlotEvent } from '../model/types';

export type StatisticsFilters = {
  airlines: string[];
  airports: string[];
  inboundAirports: string[];
  outboundAirports: string[];
  isOutbound: boolean;
  route: string | null;
};

type StatisticsState = {
  list: SlotEvent[];
  byId: Map<string, SlotEvent>;
  filters: StatisticsFilters;
};

const initialState: StatisticsState = {
  list: [],
  byId: new Map<string, SlotEvent>(),
  filters: {
    airlines: [],
    airports: [],
    inboundAirports: [],
    outboundAirports: [],
    isOutbound: true,
    route: null,
  },
};

const statisticsReducer = (
  state: StatisticsState = initialState,
  action: AnyAction
): StatisticsState => {
  switch (action.type) {
    case actionTypes.STATISTICS_GET: {
      const list = action.payload.events;
      const byId: Map<string, SlotEvent> = new Map(
        list.map((event: SlotEvent) => [event._id, event])
      );

      return {
        ...state,
        list,
        byId,
      };
    }
    case actionTypes.STATISTICS_FILTERS_SET: {
      const { filters } = action.payload;
      return {
        ...state,
        filters: { ...state.filters, ...filters },
      };
    }
    case actionTypes.STATISTICS_FILTERS_CLEAR: {
      return {
        ...state,
        filters: { ...initialState.filters },
      };
    }
    default:
      return state;
  }
};

export default statisticsReducer;
